export const createNativeBlobEventConstructor = (window) => {
    if (window !== null && window.BlobEvent !== undefined) {
        return window.BlobEvent;
    }
    return null;
};
//# sourceMappingURL=native-blob-event-constructor.js.map